import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {interval} from 'rxjs';
import {ChartComponent} from '../dashboard/chart/chart.component';
import {SpeechService} from '../../../services/speech/speech.service';

import * as hark from 'hark';
import WaveSurfer from 'wavesurfer.js';
import chroma from 'chroma-js';
import Spectrogram from 'spectrogram';

@Component({
  selector: 'app-speech',
  templateUrl: './speech.component.html',
  styleUrls: ['../../../app.component.scss', './speech.component.scss']
})
export class SpeechComponent implements OnInit, AfterViewInit {
  @ViewChild('chartComponent') chartComponent?: ChartComponent;
  private stream: any;
  audioIsActive?: boolean;
  waveformHtml: any;
  downloadLink: any;
  showDownloadLink = false;
  private ws: any;
  playingWave = false;
  shoeServiceReplyMsg = false;
  speak = false;
  spectro: any;
  audioContext?: AudioContext;

  constructor(public speechService: SpeechService) {
  }

  ngOnInit() {
    this.waveformHtml = document.getElementById('waveform')?.innerHTML;
    this.downloadLink = document.getElementById('downloadLink');
    this.audioContext = new AudioContext();
    const spe: any = document.getElementById('canvasSpectro');
    this.spectro = Spectrogram(spe, {
      audio: {
        enable: false
      },
      colors: (steps: any) => {
        const baseColors: any = [[0, 0, 255, 1], [0, 255, 255, 1], [0, 255, 0, 1], [255, 255, 0, 1], [255, 0, 0, 1]];
        // const positions: any = [0, 0.15, 0.30, 0.50, 0.75];

        const scale = chroma.scale(baseColors)
          .domain([0, steps]);

        const colors = [];

        for (let i = 0; i < steps; ++i) {
          const color = scale(i);
          colors.push(color.hex());
        }

        return colors;
      }
    });
    this.showDownloadLink = false;
    this.speechService.onPredictionWave = (url: string) => {
      this.shoeServiceReplyMsg = true;
      setTimeout(() => {
        this.shoeServiceReplyMsg = false;
      }, 1000);
      if (url) {
        this.downloadLink.href = url;
        this.downloadLink.download = 'test.wav';
        this.showDownloadLink = true;
        const waveform = document.getElementById('waveform');
        if (waveform) {
          waveform.innerHTML = '';
        }
        this.showWaves(this.downloadLink.href);
      }
    };
  }

  showWaves(url: string, onLoadCallback: any = null) {
    this.ws = WaveSurfer.create({
      container: '#waveform',
      waveColor: 'white',
      progressColor: 'red',
      mediaType: 'audio',
      normalize: true
    });
    this.ws.load(url);
    this.ws.on('ready', () => {
      if (this.playingWave) {
        this.ws.play();
      }
      if (onLoadCallback) {
        onLoadCallback();
      }
    });
  }

  playWave() {
    this.playingWave = true;
    if (this.ws != null) {
      this.ws.play();
    }
  }

  stopWave() {
    this.playingWave = false;
    if (this.ws != null) {
      this.ws.stop();
    }
  }


  ngAfterViewInit() {
    this.chartComponent?.initSound();
  }

  startAudio() {
    if (!this.audioIsActive) {
      this.audioIsActive = true;
      navigator.mediaDevices.getUserMedia({
          video: false,
          audio: true
        }
      )
        .then(stream => {


          const input = this.audioContext?.createMediaStreamSource(stream);
          const analyser = this.audioContext?.createAnalyser();

          if (analyser && input) {
            analyser.smoothingTimeConstant = 0;
            analyser.fftSize = 2048;

            input.connect(analyser);
            this.spectro.connectSource(analyser, this.audioContext);
            this.spectro.start();


            const speechEvents = hark(stream, {});

            speechEvents.on('speaking', () => {
              console.log('speaking');
              this.speak = true;
              if (!this.speechService.activeRecording) {
                this.speechService.startRecording(stream);
                this.startAutoSave();
              }
            });
            speechEvents.on('stopped_speaking', () => {
              console.log('stopped_speaking');
              this.speak = false;
            });
          }
          this.stream = stream;
        })
        .catch(error => {
          if (error) {
            console.log(error.message);
          }
          console.log('catch mediaDevices.getUserMedia(CONSTRAINS)');
        });
    }

  }

  private startAutoSave(): void {
    if (this.speechService.autoSaveMedia) {
      this.speechService.autoSaveMedia.unsubscribe();
    }
    this.speechService.autoSaveMedia = interval(2500)
      .subscribe(() => {
        this.speechService.sendMedia((url: string) => {
          if (this.speak) {
            this.speechService.startRecording(this.stream);
          }
        }, (err: any) => {
          this.stopAudio();
          setTimeout(() => {
            alert('An error occurred while communicating with the API!\nTry again another time.');
          });
        });
      });
  }

  stopAudio() {
    this.audioIsActive = false;
    this.speechService.stopRecording(() => {
      if (this.stream) {
        this.stream.getTracks().forEach((track: any) => {
          track.stop();
        });
        this.stream = null;
      }
    });
  }
}
